<template>
    <div>
        <div
            id="main-wrapper"
            data-navbarbg="skin6"
            data-theme="light"
            data-layout="vertical"
            data-sidebartype="full"
            data-boxed-layout="full"
        >
            <Header-Partial></Header-Partial>
            <div class="page-wrapper" v-bind:class="{ show: show }">
                <slot> </slot>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import HeaderPartial from "@/views/Header";
export default {
    name: "DefaultLayout",
    components: {
        HeaderPartial,
    },
    data () {
        return {
            show: false,
            accessAccount: false,
        };
    },
    created () {
        this.$store.dispatch("IngresoAccount", this.accessAccount);
    },
    computed: {
        ...mapGetters({ access: "IngresoAccount" }),
    },
};
</script>
